import { render, staticRenderFns } from "./date-picker-simple.vue?vue&type=template&id=3fc0ff24&scoped=true"
import script from "./date-picker-simple.vue?vue&type=script&lang=ts"
export * from "./date-picker-simple.vue?vue&type=script&lang=ts"
import style1 from "./date-picker-simple.vue?vue&type=style&index=1&id=3fc0ff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0ff24",
  null
  
)

export default component.exports